const standards = [
  {
    icon: 'ri-cake-3-fill',
    title: '甜度测评',
    desc: '每部甜番都标注 1-5 级甜度，从糖分浓度到名场面密度，一目了然不踩雷。',
  },
  {
    icon: 'ri-film-line',
    title: '剧情节奏',
    desc: '只看那种节奏舒服、不拖沓不注水的恋爱番，帮你把时间花在心动上。',
  },
  {
    icon: 'ri-palette-line',
    title: '画风画质',
    desc: '优先收录作画精致、氛围感强的作品，视觉享受和心动体验同样重要。',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: '口碑人气',
    desc: '综合追番同好的讨论与评分，避免冷门踩雷，也挖掘值得被看见的宝藏。',
  },
];

export default function StandardsSection() {
  return (
    <section id="standards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium">
            <i className="ri-verified-badge-line"></i>
            精选标准
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">我们如何为你挑选甜番</h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
            不是随便列个片单，而是从甜度、节奏、画风到口碑层层把关，确保每一部都值得你点开。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {standards.map((s) => (
            <div key={s.title} className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 text-center">
              <span className="inline-flex w-14 h-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className={`${s.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}